import {LocaleDictionaryPassport} from "../../interface/passport";

export const passport:  LocaleDictionaryPassport = {
    change_personal_notification : 'Full name and date of birth as in the identity document. This is necessary in order for you to get access to all the services of the RUDN',
    save_and_continue: 'Save and continue',
    save: 'Save',
    cancel: 'Cancel',
    account: 'Account',
    goToLK: 'Go to the personal account of the employee/student',
    goToAB: 'Go to the personal account of the applicant',
    registrationForm: {
        title: 'Registration',
        haveAccount : {
            name: 'Already have a RUDN account?'
        },
        loginButton: {
            name: 'Sign in'
        },
        emailForm: {
            hint: 'Email'
        },
        citizenshipSelect: {
            title: 'Identity card'
        },
        surnameForm: {
            hint: 'Surname'
        },
        nameForm: {
            hint: 'Name'
        },
        patronymicForm: {
            hint: 'Middle name'
        },
        birthdateForm: {
            title: 'Birth date',
            day: 'Day',
            month: 'Month',
            year: 'Year'
        },
        passportSeriasForm: {
            title: 'Series',
        },
        passportNumberForm: {
            title: 'Number'
        },
        continueButton: {
            name: 'Continue'
        },
        phoneConfirm: {
            name: 'Send verification code',
            callback: {
                name: "Ожидаем звонка на номер {{phone}}"
            },
            changePhoneButton: {
                name: 'Change'
            },
            confirm: {
                text: "Number {{phone}} confirmed"
            },
            chooseConfirmWay: 'Choose a verification option:',
            success: 'Number confirmed!',
            errorConfirm: 'Failed to verify phone number!',
            thanks: 'OK, thank you',
            waitingForCall: 'Waiting for a call from a number',
            processingCall: 'We are processing your call',
            codeActive: 'We are waiting for your call before time expires',
            changeWay: 'Change confirmation method',
            operationSuccess: 'Operation completed successfully',
            formWillBeUpdated: 'As soon as we receive a call, the form will update automatically',
            freeCallNumber: 'Free call to number',
            resendCode: 'Resend code',
            willBeCall: 'There will be a call to the number',
            smsSentTo: 'Sent SMS to number',
        },
        callbackAlert: {
            title: 'Phone number verification',
            choose_option:'Choose a verification option:',
            textinfo_1: 'Для продолжения регистрации вам необходимо подтвердить номер мобильного телефона',
            textinfo_2: 'Вам поступит звонок на номер',
            textinfo_3: 'Введите последние 4 цифры номера телефона входящего звонка',
            buttonConfirm: {
                name: 'Понятно'
            }
        },
        callbackByUserAlert: {
            title: 'Нам не удалось связаться с вами',
            textinfo_1: 'Вы можете подтвердить свои персональные данные позвонив по номеру',
            textinfo_2: 'Звонок для вас бесплатный, он сбросится автоматически после ряда гудков, после этого ваши данные будут подтверждены',
            buttonConfirm: {
                name: 'Понятно',
            }
        },
        inputCodeForm: {
            title: 'Enter a code'
        },
        codetimer: {
            text: 'Пытаемся с вами связаться'
        },
        passwordForm: {
            text: "Password must be of minimum 9 characters, including numbers, letters in different cases and special characters ([@#$%^&*])+!-_",
        },
        validation: {
          cyrillic_or_latin_only: 'Use Russian or Latin letters for input.',
          cyrillic_only: 'Use Russian letters for input.',
        }
    }
}
